@use "../../../../styles/Colors.scss" as Colors;
@use "../../../../styles/Constants.scss" as Constants;

.foremanToggle {
	align-items: center;
	align-self: stretch;
	border-bottom: 1px solid Colors.$col-greyMid;
	border-top: 1px solid Colors.$col-greyMid;
	border-right: 1px solid Colors.$col-greyMid;
	box-sizing: border-box;
	cursor: pointer;
	display: flex;
	flex: 0 0 Constants.$val-spacing-l;
	justify-content: center;
	margin: 0;

	input {
		margin: 0;
	}
}